import PropTypes from 'prop-types';
import React from 'react';

import { OrderStatusBadge } from '@hero/components/molecules';

function StatusCell({ getValue }) {
  const value = getValue();

  return <OrderStatusBadge status={`${value}Invite`} />;
}

StatusCell.propTypes = {
  getValue: PropTypes.func
};

export { StatusCell };
